// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const OtherInstruction = t.struct({
    description: t.String,
    id: t.String
}, {
    name: 'OtherInstruction',
    strict: true
});

export const getDefaultState = () => new OtherInstruction({
    description: '',
    id: ''
});

export default OtherInstruction;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/other-instruction.js